/**
 * Chart colors palette
 */
export default {
  chartBackground: "#fff",
  rangeSelectorButtonBackground: "#1B2D51",
  rangeSelectorButtonBackgroundHover: "#1B2D51",
  rangeSelectorButtonBackgroundSelect: "#1B2D51",
  rangeSelectorTextColor: "#1B2D51",
  rangeSelectorButtonColor: "#fff",
  contrastTextColor: "#1B2D51",
  textColor: "#1B2D51",
  axisLineColor: "#eaebf2"
}
